export default "__VITE_ASSET__8f7c8351__"